import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { ReactComponent as SmallKimsLogo } from '../../icons/small_kims.svg';
import { ReactComponent as LocationIcon } from 'common/icons/location.svg';
import IconButton from 'common/components/IconButton';
import useSearch from 'common/hooks/useSearch';
import SearchInput from 'common/components/SearchInput';

const VacancyWrapper = styled.div`
        display:flex;
        flex-direction: column;
        padding: 16px;
        border-radius: 16px;
        border: 1px solid ${(props) => props.theme.colors.gray};
        gap: 20px;
`;

type VacancyProps = {
  title: string;
  date: string;
  location: string;
};

function formatDate(date: string): string {
  const today = new Date();
  const [year, month, day] = date.split('-');
  const formattedDate = new Date(Number(year), Number(month) - 1, Number(day));

  const diffTime = Math.abs(today.getTime() - formattedDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  console.log(today);
  console.log(formattedDate);
  console.log(diffTime);
  if (diffDays === 0) {
    return 'сьогодні';
  } else if (diffDays === 1) {
    return 'вчора';
  } else if (diffDays <= 7) {
    // if 1 день тому, 2 дні тому, 3 дні тому, 4 дні тому, >5 днів тому
    switch (diffDays) {
      case 1:
        return '1 день тому';
      case 2:
        return '2 дні тому';
      case 3:
        return '3 дні тому';
      case 4:
        return '4 дні тому';
      default:
        return `${diffDays} днів тому`;
    }
  } else if (diffDays <= 14) {
    return 'тиждень тому';
  } else if (diffDays <= 30) {
    return 'місяць тому';
  } else {
    return date;
  }
}

const VacancyList: VacancyProps[] = [
  {
    title: 'Хімчистильник',
    date: formatDate('2023-11-29'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Майстер із реставрації текстилю',
    date: formatDate('2023-11-28'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Адміністратор відділу',
    date: formatDate('2023-11-27'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Фахівець із обробки шкіри',
    date: formatDate('2023-11-26'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Швачка/Швiя-ремонтниця',
    date: formatDate('2023-11-20'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Технолог з хімічного чищення',
    date: formatDate('2023-11-10'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Фахівець із клієнтського обслуговування',
    date: formatDate('2023-9-29'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Менеджер із закупівель та інвентаризації',
    date: formatDate('2022-11-29'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Мийник/Мийниця',
    date: formatDate('2021-11-29'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
  {
    title: 'Еколог з безпеки хімчистки',
    date: formatDate('2020-11-29'),
    location: 'Одесса, вул. Люстдорфська дорога, 5',
  },
];

const Vacancy = ({ date, location, title }: VacancyProps) => {
  const theme = useTheme();
  const [isEventSaved, setIsEventSaved] = useState(false);
  return (
                <VacancyWrapper>
                        <div className='account-event-top-line'>
                                <div className='account-event-user'>
                                        <div style={{ border: `1px solid ${theme.colors.gray}` }} className='account-event-user-avatar-wrapper'>
                                                <SmallKimsLogo height={30} width={30} />
                                        </div>
                                        <div className='account-post-user'>
                                                <span className='account-event-user-name'>Хімчистка KIMS</span>
                                                <div style={{ backgroundColor: theme.colors.primaryColor }} className='account-event-verification-wrapper'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M12 6L6.5 11L4 8.72727" stroke="#F7F7F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                </div>
                                        </div>
                                </div>
                                <div className='account-vacancy-top-right'>
                                        <span className='account-event-date'>{date}</span>
                                        <IconButton size={30} onClick={() => setIsEventSaved(!isEventSaved)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                        <path d="M12 16L19 21V2H5V21L12 16Z" fill={isEventSaved ? theme.colors.primaryColor : 'transparent'} stroke={theme.colors.black} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                        </IconButton>
                                </div>
                        </div>
                        <div className='account-vacancy-content'>
                                <p className='new-p account-vacancy-title'>{title}</p>
                                <div className='account-vacancy-location-wrapper'>
                                        <LocationIcon height={16} width={16} fill={theme.colors.gray} />
                                        <span className='account-vacancy-location gray-text'>{location}</span>
                                </div>
                        </div>
                </VacancyWrapper>
  );
};

const SearchWrapper = styled.div`
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    display: flex;
    flex-direction: column;
`;

export default function VacanciesPage() {
  console.log(VacancyList[0].date);
  const { searchValue, onSearchChange } = useSearch();
  const searchedVacancies = VacancyList.filter((event) => event.title.toLowerCase().includes(searchValue.toLowerCase()));
  return (
        <div className='account-vacancies-section'>
            <SearchWrapper>
                <span className='new-p' style={{ marginBottom: '20px', textAlign:'center' }}>
                У компанії <span className='bold-text'>“Хімчистка KIMS”</span> відкрито 10 вакансій — може ми шукаємо саме Вас!
                </span>
                <SearchInput wrapperStyle={{ width:'100%', marginBottom:'16px' }} value={searchValue} onChange={onSearchChange} placeholder='Пошук...' />
                <div className='account-vacancies-search-links'>
                    <span className='basic-link'>Технічний спеціаліст</span>
                    <span className='basic-link'>Оператор</span>
                    <span className='basic-link'>Прачка</span>
                    <span className='basic-link'>Кур’єр</span>
                </div>
            </SearchWrapper>  
            <div className='account-events-list'>
                {!searchedVacancies ? VacancyList.map((vacancy, index) => (
                    <Vacancy
                        key={index}
                        title={vacancy.title}
                        date={vacancy.date}
                        location={vacancy.location}
                    />
                )) : searchedVacancies.map((vacancy, index) => (
                    <Vacancy
                        key={index}
                        title={vacancy.title}
                        date={vacancy.date}
                        location={vacancy.location}
                    />
                ))}
            </div>
        </div>
  );
}